import { createSvgIcon } from "@mui/material";

export const PaymentSettingsIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path d="M1.875 6.875H16.875M1.875 6.875V5.625C1.875 4.93464 2.43464 4.375 3.125 4.375H15.625C16.3154 4.375 16.875 4.93464 16.875 5.625V6.875M1.875 6.875V7.5M16.875 6.875V7.5M1.875 7.5H16.875M1.875 7.5V15.625C1.875 16.3154 2.43464 16.875 3.125 16.875H15.625C16.3154 16.875 16.875 16.3154 16.875 15.625V7.5M4.375 11.875H9.375M4.375 13.75H6.875" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'PaymentSettingsIcon'
)
